import * as React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { NameValueList } from '../../NameValueList/NameValueList'
import { useData } from './hooks'
import { InfoBlurb } from '../WebformSideDrawerContents/InfoBlurb'
import { SubmissionInfo } from '../WebformSideDrawerContents/SubmissionInfo'

type Props = {
  hideInfoBox?: boolean
  type: string
  webFormCallTrackingEventId?: string | null
  submittedBy?: string
  dateSubmittedFormat?: string
}

export function CTMWebformSideDrawerContents(props: Props) {
  const {
    hideInfoBox = false,
    submittedBy,
    webFormCallTrackingEventId,
    dateSubmittedFormat,
  } = props
  const { status, nameValueList, webformData } = useData({
    webFormCallTrackingEventId,
  })

  return (
    <>
      {status === 'pending' ? (
        <CircularProgress />
      ) : (
        <>
          {!hideInfoBox && <InfoBlurb />}
          <SubmissionInfo
            submittedBy={submittedBy}
            dateSubmitted={dateSubmittedFormat || webformData?.createdTime}
            {...props}
          />
          <NameValueList
            excludeNames={['SUBMITTEDBY', 'Type']}
            list={nameValueList}
            divider={false}
          />
        </>
      )}
    </>
  )
}
